import { H } from "highlight.run";
import admins from "../../services/admins";

export const init = () => {
    if (process.env.ENVIRONMENT_NAME === "prod")
        H.init("4d731xgo", {
            environment:
                process.env.ENVIRONMENT_NAME === "prod"
                    ? "production"
                    : process.env.ENVIRONMENT_NAME,
            version: process.env.COMMIT_SHA,
            enableStrictPrivacy: false,
            networkRecording: {
                enabled: true,
                recordHeadersAndBody: true,
            },
        });
};

export const identify = (jwt, user) => {
    const isDelegatedAccess =
        user && jwt && user.id !== jwt.sub && admins.find((admin) => admin.userId === jwt.sub);

    if (process.env.ENVIRONMENT_NAME !== "prod") return;
    let displayName;
    if (user && user.name && (user.name.familyName || user.name.givenName)) {
        displayName = `${user.name.givenName} ${user.name.familyName}`;
    }

    if (isDelegatedAccess) {
        // eslint-disable-next-line consistent-return
        return H.identify(isDelegatedAccess.emails[0], { id: jwt.sub });
    }
    H.identify(user.emails[0], {
        id: jwt.sub,
        highlightDisplayName: user.displayName || displayName,
        accountType:
            user.plans && user.plans.length > 0 && user.plans.map((plan) => plan.name).join("_"),
        avatar: user.picture,
        orgId: user.orgId,
    });
};
